import { useEffect, useState } from 'react';

export function useIsOnMobileDevice() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const userAgent = typeof window !== 'undefined' ? navigator.userAgent : '';
    setIsMobile(/Mobi|Android|iPhone/i.test(userAgent));
  }, []);

  return isMobile;
}
